import { useState, useContext } from "react";
import "../../Style/actionstyle.scss";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { AuthContext } from "../../Context/AuthContext";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
import OptionPriceForm from "./OptionPriceForm";
import useDeleteOptionPrice from "./Hooks/useDeleteOptionPrice";
import DialogDelete from "../../Utils/DialogDelete";

export default function OptionPriceAction({ editData, setRefetch, classId }) {
  // Change Language
  const { t } = useContext(AuthContext);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  const { handleDelete, loading } = useDeleteOptionPrice({
    handleClose: handleCloseDel,
    id: editData?._id,
    setRefetch,
  });

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title={t("update")} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <MdModeEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        <Tooltip title={t("delete")} placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      {openEdit && (
        <OptionPriceForm
          dialogTitle={"Update"}
          open={openEdit}
          editData={editData}
          setRefetch={setRefetch}
          handleClose={handleCloseEdit}
          classId={classId}
        />
      )}

      {openDel && (
        <DialogDelete
          open={openDel}
          handleClose={handleCloseDel}
          loading={loading}
          deleteTitle={t("modal_title_delete_option_price")}
          handleDelete={handleDelete}
          editData={editData}
        />
      )}
    </div>
  );
}
